import { useSettingsStore } from "@/store/settingsStore";

const RADIUS = 20;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function CountdownCircle({ countdown }: { countdown: number }) {
  const countdownSeconds = useSettingsStore(state => state.countdownSeconds);
  const total = Math.max(1, countdownSeconds);
  const ratio = Math.min(1, Math.max(0, countdown / total));
  const dashOffset = -CIRCUMFERENCE * (1 - ratio);

  return (
    <div className="relative size-8 flex items-center justify-center">
      <svg className="absolute inset-0 -rotate-90" width="32" height="32" viewBox="0 0 48 48">
        <circle cx="24" cy="24" r={RADIUS} fill="none" stroke="#e2e8f0" strokeWidth="4" />
        <circle
          cx="24"
          cy="24"
          r={RADIUS}
          fill="none"
          stroke="var(--primary)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={dashOffset}
        />
      </svg>
      <span className="relative text-xs font-bold text-primary">{Math.ceil(countdown)}</span>
    </div>
  );
}
